import React, { useEffect, useRef, useState } from "react";
import styles from "./ServicesSection.module.css";
import bgImage from "../../assets/DimoraImages/IMG_0232.jpg";
import { SERVICES_SECTION_CONTENT } from "../../Constants";
import { useNavigate } from "react-router-dom";

const ServicesSection = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/contact");
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.35 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`${styles.section} ${visible ? styles.show : ""}`}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className={styles.overlay}></div>

      <div className={styles.container}>
        {/* LEFT CONTENT */}
        <div className={styles.left}>
          <h2>
            {SERVICES_SECTION_CONTENT.headingLine1} <br />
            {SERVICES_SECTION_CONTENT.headingLine2}
          </h2>

          <p>{SERVICES_SECTION_CONTENT.description}</p>

          <button className={styles.btn} onClick={handleNavigate}>
            {SERVICES_SECTION_CONTENT.buttonText}
          </button>
        </div>

        {/* RIGHT SERVICES */}
        <div className={styles.right}>
          {SERVICES_SECTION_CONTENT.services.map((title, i) => (
            <div
              key={title}
              className={styles.serviceItem}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <h3>{title}</h3>
              <div className={styles.line}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;